// src/components/widgets/AddOrganisation.js
import React, { useState } from 'react';
import { apiService } from '../services/api'; // Adjust path if needed
import './style/AddOrganisation.css'; 

const AddOrganisation = ({ onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    customId: '',
    type: 'National Account',
    contactEmail: '',
    location: '',
    description: '',
    rebate: '',          
    redistribution: ''   
  });

  const [error, setError] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const orgTypes = ['Head Office Account','National Account', 'Board', 'Supplier', 'Utilities', 'Wholesaler', 'Customer'];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (error) setError('');
  };

  const handleSubmit = async () => {
    if (!formData.name.trim() || !formData.contactEmail.trim()) {
      setError('Organisation Name and Contact Email are required.');
      return;
    }

    setIsSaving(true);
    setError('');

    try {
      // 1. Call API here
      const response = await apiService.addOrganisation(formData);
      
      // 2. Construct the final object to update the UI immediately
      const newOrganisation = {
        ...formData,
        id: response.id // Use the ID returned from the database
      };

      // 3. Pass the data to parent to update the list (BUT DO NOT CALL API IN PARENT)
      if (onSave) {
        onSave(newOrganisation);
      }
      
      onClose();
    } catch (err) {
      console.error("Failed to create organisation:", err);
      setError('Failed to create organisation. Please check your connection and try again.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="widget-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="widget-header">
          <h2>Add New Organisation</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="widget-content">
          <div className="form-grid">
            <div className="form-group">
              <label>Organisation ID (Custom)</label>
              <input 
                type="text" 
                name="customId" 
                className="widget-input" 
                placeholder="e.g. 1001 or CUST-A" 
                value={formData.customId} 
                onChange={handleInputChange} 
                disabled={isSaving} 
              />
            </div>

            <div className="form-group">
              <label>Organisation Name <span style={{color: '#dc3545'}}>*</span></label>
              <input type="text" name="name" className="widget-input" placeholder="e.g. Red Bull" value={formData.name} onChange={handleInputChange} disabled={isSaving} />
            </div>

            <div className="form-group">
              <label>Organisation Type</label>
              <select name="type" className="widget-input" value={formData.type} onChange={handleInputChange} disabled={isSaving}>
                {orgTypes.map(type => <option key={type} value={type}>{type}</option>)}
              </select>
            </div>

            <div className="form-group">
              <label>Contact Email <span style={{color: '#dc3545'}}>*</span></label>
              <input type="email" name="contactEmail" className="widget-input" placeholder="admin@example.com" value={formData.contactEmail} onChange={handleInputChange} disabled={isSaving} />
            </div>

            <div className="form-group">
              <label>Address (Optional)</label>
              <input type="text" name="location" className="widget-input" placeholder="City, State" value={formData.location} onChange={handleInputChange} disabled={isSaving} />
            </div>


            <div className="form-group">
              <label>Rebate %</label>
              <input type="number" step="0.01" name="rebate" className="widget-input" placeholder="e.g. 5.5" value={formData.rebate} onChange={handleInputChange} disabled={isSaving} />
            </div>

            <div className="form-group">
              <label>Redistribution %</label>
              <input type="number" step="0.01" name="redistribution" className="widget-input" placeholder="e.g. 10" value={formData.redistribution} onChange={handleInputChange} disabled={isSaving} />
            </div>


            <div className="form-group full-width">
              <label>Description (Optional)</label>
              <textarea name="description" className="widget-input" placeholder="Enter description..." value={formData.description} onChange={handleInputChange} disabled={isSaving} rows="3" />
            </div>

            {error && <div style={{color: '#dc3545', marginBottom: '10px'}}>{error}</div>}
          </div>

          <div className="tab-actions">
            <button className="action-btn secondary" onClick={onClose} disabled={isSaving}>Cancel</button>
            <button className="action-btn primary" onClick={handleSubmit} disabled={isSaving}>
              {isSaving ? 'Creating...' : 'Create Organisation'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOrganisation;
